import { Box } from '@mui/material'
import { BaseTable } from 'Features/Projects/Table/BaseTable.view'
import { ComparisonTableType } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'

type ComparisonTableProps = {
  data: ComparisonTableType[]
  isLoading: boolean
}

export const ComparisonTable = ({ data, isLoading }: ComparisonTableProps) => {
  const COLUMN_WIDTH = 175

  const columns: GridColDef[] = [
    {
      field: 'skuGroupCode',
      headerName: 'SKU Group Code',
      minWidth: COLUMN_WIDTH,
      flex: 1,
    },
    {
      field: 'skuGroupName',
      headerName: 'SKU Group Name',
      minWidth: COLUMN_WIDTH + 100,
      flex: 1,
    },
    {
      field: 'startWeek',
      headerName: 'Start Week',
      width: COLUMN_WIDTH - 50,
      type: 'number',
    },
    {
      field: 'cycleTime',
      headerName: 'Cycle Time',
      width: COLUMN_WIDTH - 50,
      type: 'number',
    },
    {
      field: 'currentStartWeek',
      headerName: 'Current Start Week',
      width: COLUMN_WIDTH,
      type: 'number',
      renderCell: (params: GridRenderCellParams) => {
        const { value } = params
        return <Box>{value === -1 ? <div></div> : value}</Box>
      },
    },
    {
      field: 'currentCycleTime',
      headerName: 'Current Cycle Time',
      width: COLUMN_WIDTH,
      type: 'number',
      renderCell: (params: GridRenderCellParams) => {
        const { value } = params
        return <Box>{value === -1 ? <div></div> : value}</Box>
      },
    },
  ]

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
      }}
    >
      <BaseTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        updateTableData={() => {}}
        uploadData={() => {}}
        isUploading={false}
        isSaving={false}
      />
    </Box>
  )
}
